<template>
    <div>
        <div class="page">
            <div class="container px-11 2xl:px-3 my-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-resolution_blue',
                        to: 'to-dodger_blue',
                    }"
                >
                    <h1 v-html="currentPage.content.pageTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.pageDescription.text"
                ></p>

                <div class="container-components">
                    <div>
                        <image-with-descriptions style="margin:0; margin-bottom: 1.25rem;"
                            :options="{
                                image300:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image1.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image1.text,
                                        position: 'top-center', // top/bottom-left/right
                                        orientation: 'horizontal-custom-1', // vertical, horizontal
                                        fontSize: 'lg:text-lg -mt-2 lg:-mt-6'
                                    },
                                    {
                                        text: currentPage.images.image1.edf,
                                        position: 'top-center', // top/bottom-left/right
                                        orientation: 'horizontal-custom-1', // vertical, horizontal
                                        fontSize: 'mt-10 -mr-8 md:left-8 md:right-20 lg:-mr-12'
                                    },
                                    {
                                        text: currentPage.images.image1.alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>

                    

                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="currentPage.content.firstSubTitle.text"
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.secondParagraph.text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>
                    <div>
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image2.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image2.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>

                    <div class="card" style="padding-top: 0;">
                        <div class="break-inside-avoid">
                            <!-- <div class="relative">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            `… tutoie les cieux de Dubaï/téléphérique`
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                            </div> -->
                            
                        </div>

                        <div class="card break-inside-avoid">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="currentPage.content.secondSubTitle.text"
                            ></span>
                        </TitleParagraph>
                        
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="currentPage.content.thirdParagraph.text"
                            >
                            </span>
                        </paragraph>
                        <div>
                                <image-with-descriptions class="eliminate-margin"
                                    :options="{
                                        image:
                                            'pages/' +
                                            currentPage.slug +
                                            '/' +
                                            currentPage.images.image3.src,
                                        descriptions: [
                                            {
                                                text: currentPage.images.image3
                                                    .edf,
                                                position: 'bottom-right', // top/bottom-left/right
                                                orientation: 'horizontal', // vertical, horizontal
                                            },
                                        ],
                                    }"
                                />
                            </div>
                    </div>
                    </div>

                    <div class="card">
                        <!-- <div class="break-inside-avoid"> -->
                            <!-- <div class="relative">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            `… tutoie les cieux de Dubaï/téléphérique`
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                            </div> -->
                            <div class="break-inside-avoid">
                                <image-with-descriptions
                                    :options="{
                                        image:
                                            'pages/' +
                                            currentPage.slug +
                                            '/' +
                                            currentPage.images.image4.src,
                                        descriptions: [
                                            {
                                                text: currentPage.images.image4
                                                    .edf,
                                                position: 'bottom-right', // top/bottom-left/right
                                                orientation: 'horizontal', // vertical, horizontal
                                            },
                                        ],
                                    }"
                                />
                        
                                <TitleParagraph
                                    :options="{
                                        from: 'from-resolution_blue',
                                        to: 'to-dodger_blue',
                                    }"
                                >
                                    <Triangles
                                        :options="{
                                            colors: [
                                                '#00357f',
                                                '#0b4f9c',
                                                '#0d94ff',
                                            ],
                                            direction: 'top',
                                        }"
                                    />
                                    <span
                                        v-html="
                                            currentPage.content.thirdSubTitle.text
                                        "
                                    ></span>
                                </TitleParagraph>
                                 <paragraph
                                    :options="{
                                        color: 'text-nandor',
                                    }"
                                >
                                    <span
                                        v-html="
                                            currentPage.content.fourthParagraph.text
                                        "
                                    >
                                    </span>
                                </paragraph>
                            </div>
                       
                        <div class="relative">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        `Le projet de téléphérique Dubaï Summit à Hatta`
                                    ),
                                }"
                                class="top-2 right-2"
                            />
                        </div>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image5.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image5
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.image5.alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>

                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="currentPage.content.fourthSubTitle.text"
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="currentPage.content.fifthParagraph.text"
                            >
                            </span>
                            <!-- <square
                                :options="{
                                    from: 'from-resolution_blue',
                                    to: 'to-dodger_blue',
                                }"
                            /> -->
                        </paragraph>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang="scss">
</style>
